<template>
  <div class="filter-radio__options">
    <div
      v-for="radioItem in radioItems"
      :key="radioItem.id"
      :class="`filter-radio__options__option ${ isRadioItemSelected(radioItem) && 'filter-radio__options__option--selected-value'}`"
      @click="$event => setSelectedRadioItem(radioItem.id)"
    >
      <span class="filter-radio-item-input" /> <span>{{ radioItem.name }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RadioInputFilter',
  props: {
    scrollable: {
      type: Boolean,
      default: false,
    },
    radioItems: {
      type: Array,
      default: () => [],
    },
    selectedRadioItem: {
      type: [Number, String],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {
    toggleExpand() {
      if (this.disabled) {
        return;
      }
      this.isExpanded = !this.isExpanded;
    },
    setSelectedRadioItem(radioItemValue) {
      this.$emit('filter-radio-item-selected', radioItemValue);
    },
    isRadioItemSelected(radioItem) {
      return this.selectedRadioItem && this.selectedRadioItem === radioItem.id;
    },
  },
};
</script>
  <style lang="scss" scoped>

  .filter-radio-item-input {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    border-radius: 50%;
    display: flex;
    background-color: white;
    border: solid thin #ababab;
  }

  .filter-radio {
    &__title{
      margin-top: 0.5rem;
      color: $dark-black;
    }
    &__options {
      display: flex;
      flex-wrap: wrap;
      flex-flow: column;
      row-gap: 8px;
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      cursor: pointer;

      &__option {
        display: flex;
        flex-wrap: wrap;
        font-family: "SilkaLight";
        font-weight: 400 !important;
        font-size: 14px;

        &:hover {
          opacity: 0.6;

          .filter-radio-item-input {
            border: solid thin #7e7e7e;
          }
        }

        &--selected-value {
          .filter-radio-item-input {
            position: relative;
            display: flex;
            flex-flow: row;
            justify-content: center;
            align-items: center;
            border: solid 1px $gray-100;

            &:before {
              background-color: $gray-100;
              border-radius: 50%;
              width: 12px;
              height: 12px;
              content: '';
            }

            &:hover {
              background-color: #7e7e7e;
            }
          }
        }
      }
    }
    &--scrollable {
      overflow-y: auto;
      max-height: 100vh;
    }
    &__disabled{
      color: $gray-light-2;
      :hover{
        cursor: not-allowed;
      }
    }
  }
  .subitem{
    max-height: 234px;
    overflow-y: hidden;
  }
  ::v-deep .base-checkbox__button {
    display: flex;
    & .base-checkbox__label {
      display: inline-block;
    }
  }

  ::v-deep .base-text--light{
    font-family: "SilkaMedium"
  }

</style>
